import { Box, IconButton } from "@mui/material"
import GradeIcon from "@mui/icons-material/Grade"
import { useEffect, useState } from "react"
import { useApiService } from "../hooks/Api/useApiService"
import styles from "./Rating.module.css"
import useError from "../hooks/Error/useError"

const Rating = (props) => {
  const [ratings, setRatings] = useState([
    { number: 1, color: "gray" },
    { number: 2, color: "gray" },
    { number: 3, color: "gray" },
    { number: 4, color: "gray" },
    { number: 5, color: "gray" },
  ])
  const { postData } = useApiService()
  const [rated, setRated] = useState(false)
  const { Error: AlertError, error, success } = useError()

  useEffect(() => {
    postData("sharie/getrating", { name: props.name, from: props.from, to: props.to })
      .then((data) => {
        if (data.message === "Failed") {
          error("No Such Skill!")
        } else {
          determineRating(data.rating)
          setRated(data.rated)
        }
      })
      .catch((error) => {})
  }, [])

  const determineRating = (rating) => {
    const new_ratings = ratings.map((el) => {
      if (el.number <= rating) {
        return { number: el.number, color: "#0096FF" }
      } else {
        return { number: el.number, color: "gray" }
      }
    })

    setRatings(new_ratings)
  }
  const handleRating = (rating) => {
    props.setRatingUpdated(true)
    determineRating(rating)
    if (!rated) {
      try {
        postData("sharie/addnotification", {
          skill_name: props.name,
          from: localStorage.getItem("user"),
          type: "rated skill",
          to: props.to,
        }).then((data) => {})
      } catch (error) {
        console.error("Error sending notification:", error)
      }
      postData("sharie/updaterating", {
        name: props.name,
        from: props.from,
        to: props.to,
        date_time: props.date_time,
        rating: rating,
      })
        .then((data) => {
          if (data.rating) {
            determineRating(data.rating)
            success("Rating " + rating + " Stars Sent")
          }
        })
        .catch((error) => {})
    } else {
      error("Already Rated")
    }
  }
  const getRating = () => {
    let i = 0
    ratings.forEach((el) => {
      if (el.color !== "gray") {
        i++
      }
    })
    return i
  }

  return (
    <Box className={styles.rating_container}>
      {ratings.map((el, index) => {
        return (
          <IconButton
            key={index}
            onClick={() => handleRating(el.number)}
            aria-label='rate'
            className={styles.icon}
          >
            <GradeIcon style={{ color: el.color }} />
          </IconButton>
        )
      })}
      <AlertError />
    </Box>
  )
}
export default Rating
